class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector('details');
		this.onDocumentClick = this.onFocusOut.bind(this);
	}

	connectedCallback() {
		this.addEventListener('keyup', this.onKeyUp);
		document.addEventListener('click', this.onDocumentClick);
	}

	disconnectedCallback() {
		this.removeEventListener('keyup', this.onKeyUp);
		document.removeEventListener('click', this.onDocumentClick);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector('summary');
		openDetailsElement.removeAttribute('open');
		summaryElement.focus();
	}

	onFocusOut(e) {
		const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

		if (!withBoundaries) {
			this.mainDetailsToggle.removeAttribute('open');
		}
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
	}
}

customElements.define('details-disclosure', DetailsDisclosure);
